import BaseService from './_base.service';

export const typeLensService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/typelens/page/"+page+"/"+size, callback, true)
}

function search(page,size,filter, callback) {
    return BaseService.post("/typelens/page/"+page+"/"+size,filter, callback, true)
}

function combo(callback) {
    return BaseService.get("/typelens/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/typelens/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/typelens/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/typelens/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/typelens/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/typelens/"+id+"/logic", callback);
}
